import { useQuery, UseQueryOptions } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { WizardDraft, WizardDraftClient } from 'api/clients/WizardDraftClient'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

type Data = WizardDraft[]

export const useWizardDrafts = (options?: UseQueryOptions<Data>) => {
  const currentWorkspaceId = useCurrentWorkspaceId()

  return useQuery<Data>(
    ['wizardDrafts', currentWorkspaceId],
    async () => {
      const response = await WizardDraftClient.getAllDrafts(currentWorkspaceId)

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('An error occurred fetching drafts! Our team has been notified and we are looking into it.')
      }
      return response.data
    },
    {
      ...options,
    },
  )
}
